import { render, staticRenderFns } from "./MainPlugin.vue?vue&type=template&id=04806709&scoped=true&"
import script from "./MainPlugin.vue?vue&type=script&lang=js&"
export * from "./MainPlugin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04806709",
  null
  
)

export default component.exports